import PropTypes from 'prop-types'
import React from 'react'
import Modal from 'components/Modal'

const AlertTitle = Modal.Header

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Alert = ({ className, children, title, ...props }) => (
  <Modal {...props}>
    {title && <AlertTitle>{title}</AlertTitle>}
    {children}
  </Modal>
)

Alert.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
}

Alert.Body = Modal.Body
Alert.Footer = Modal.Footer
Alert.Title = AlertTitle

// Backwards compatibility
export const AlertMessage = Modal.Body
export const AlertControls = Modal.Footer

export default Alert
